import { Module, ModuleTree } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { state } from "./state";
import { getters } from "./getters";
import user from "../User/index";
import role from "../Role/index";
import agence from "../Agence/index";
import state_ from "../State/index";
import device from "../Device/index";
import category from "../Category/index";
import survey from "../Survey/index";
import poste from "../Poste/index";
import log from "../Log/index";
import historic from "../Historic/index";
import camera_resolution from "../CameraResolution/index";
import main_state_ from "../MainState";
import camera_image from "../CameraImage";

const modules: ModuleTree<any> = {
  user,
  role,
  agence,
  state_,
  device,
  category,
  survey,
  poste,
  log,
  historic,
  camera_resolution,
  main_state_,
  camera_image
};

const auth: Module<any, any> = {
  state,
  mutations,
  getters,
  actions,
  modules
};

export default auth;
